export default __webpack_public_path__ + "static/blob5-221f5b20c9e0c53e9b719e657c9540e8.svg";